// extracted by mini-css-extract-plugin
export var colorSquare = "_r6-0";
export var danger = "_r6-5";
export var lightPink = "_r6-8";
export var neutralBlue = "_r6-7";
export var neutralYellow = "_r6-6";
export var normal = "_r6-1";
export var primary = "_r6-2";
export var primaryLight = "_r6-3";
export var solidBlack = "_r6-g";
export var solidGreen = "_r6-b";
export var solidLightBlue = "_r6-d";
export var solidNavy = "_r6-c";
export var solidOrange = "_r6-f";
export var solidPink = "_r6-e";
export var solidRed = "_r6-9";
export var solidYellow = "_r6-a";
export var success = "_r6-4";